import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';
import { getErrorMessage } from 'queries/utils';

export function useAiInsightsCounter<TData = Api.V4.Bulletins.AiInsightsCounter.Response>(
    options?: UseExposedQueryOptions<Api.V4.Bulletins.AiInsightsCounter.Response, Error, TData>
) {
    const notify = useNotify();

    return useQuery<Api.V4.Bulletins.AiInsightsCounter.Response, Error, TData>({
        ...options,
        queryKey: Api.V4.Bulletins.AiInsightsCounter.QueryKey(),
        queryFn: async () => {
            try {
                const response = await new RequestAgent().public.get(Api.V4.Bulletins.AiInsightsCounter.Endpoint());

                return response.result;
            } catch (error) {
                notify.openNotification({ level: 'error', message: getErrorMessage(error) });
                throw error;
            }
        }
    });
}
